<template>
  <div class="bg-white">
    <CoverPage />

    <LatestNews />
    <div class="bge3ceff-opa rounded-t-5555 mt-12 relative zindex1">
      <div class="absolute -top-56 right-8 md:block lg:block hidden">
        <img
          src="./../../../assets/images/bg-des/footer-bg.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import CoverPage from "./components/CoverPage.vue";
import DownloadApp from "../../home/components/DownloadApp.vue";
import LatestNews from "./components/LatestNews.vue";
import Footer from "../../Footer.vue";
export default {
  components: {
    CoverPage,
    DownloadApp,
    Footer,
    LatestNews,
  },
  metaInfo: {
    title: "In the news - Caregiver Saathi",
    meta: [
      {
        name: "keyword",
        content:
          "Caregiver caregiving, agencies for caregivers,agencies for home care,assisted home care services,home care agency,home care for elderly,home care for seniors,at home nurse care,at home senior care services,care for the caregiver program,caregiver burden,wellness,well-being,health and well-being,mental health,physical health,psychological wellbeing,caregiver needs,caregiver burnout,caregiver stress,family caregiver,caregiver companion,respite care,attendant,patient support,nursing services,caregiving services,caregiver websites,Caregiving training,Caregiver support,Caregiving for specific needs,Caregiving training near me,Caregivers for seniors,Caregiving agencies,caregiving agencies in Mumbai,Caregiving and compassionate reasons,Caregiving for healthcare professionals,counselling,therapy,coaching,caregiver coaching,palliative care,caregiving support for cancer patient,attendant for dementia patient,helpline for caregiving,grief support group,volunteering,volunteering opportunities in India,grief management,employee well-being,corporate services,online forum for caregiver,community for caregivers,bhavana Issar,online learning,care management,caregiving courses,",
      },
      {
        name: "description",
        content:
          "We are in the news! Catch up on all the media highlights on Caregiver Saathi.",
      },
    ],
  },
};
</script>
